// formatBytes converts a byte count to a short human-readable string.
// Mirrors the helper inside FileDropzone, exported here so anything that
// shows a file/disk size renders it identically (B / KB / MB / GB).
export function formatBytes(n: number): string {
  if (n < 1024) return `${n} B`;
  if (n < 1024 * 1024) return `${(n / 1024).toFixed(1)} KB`;
  if (n < 1024 * 1024 * 1024) return `${(n / 1024 / 1024).toFixed(1)} MB`;
  return `${(n / 1024 / 1024 / 1024).toFixed(2)} GB`;
}
